import React from 'react'
import styled from 'styled-components'
import Image from 'components/common/Image'
import whiteArrowLeftSVG from 'assets/images/tw-icon-arrow-left.svg'
import whiteSettingSVG from 'assets/images/tw-icon-setting.svg'
import blackArrowLeftSVG from 'assets/images/tw-icon-black-arrow-left.svg'
import blackSettingSVG from 'assets/images/tw-icon-black-setting.svg'
import { Typography } from 'components/common'
import theme from 'theme'

interface NavigationProps {
    readonly showLeftIcon?: boolean
    readonly showRightIcon?: boolean
    readonly isPrimary?: boolean
    readonly title?: string
    readonly showTitle?: boolean
    readonly onClickLeftIcon?: () => void
    readonly onClickRightIcon?: () => void
}

const Navigation = ({
    showLeftIcon,
    showRightIcon,
    showTitle = true,
    isPrimary,
    title,
    onClickLeftIcon,
    onClickRightIcon,
}: NavigationProps): JSX.Element => {
    return (
        <Container>
            <LeftIcon>
                {showLeftIcon && (
                    <Image
                        src={isPrimary ? whiteArrowLeftSVG : blackArrowLeftSVG}
                        height="24px"
                        width="24px"
                        onClick={onClickLeftIcon}
                        style={{ cursor: 'pointer' }}
                        data-testid="leftIconId"
                    />
                )}
            </LeftIcon>
            {showTitle && (
                <Typography.Title
                    weight="font-normal"
                    style={{
                        color: isPrimary
                            ? theme.TSEL.color.light
                            : theme.TSEL.color.dark,
                    }}
                    className="text-sm md:text-lg lg:text-xl"
                >
                    {title}
                </Typography.Title>
            )}
            <RightIcon>
                {showRightIcon && (
                    <Image
                        src={isPrimary ? whiteSettingSVG : blackSettingSVG}
                        height="24px"
                        width="24px"
                        onClick={onClickRightIcon}
                        style={{ cursor: 'pointer' }}
                        data-testid="rightIconId"
                    />
                )}
            </RightIcon>
        </Container>
    )
}

export default Navigation

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    gap: 16px;
    margin-top: 20px;
`

export const LeftIcon = styled.div`
    height: 24px;
    width: 24px;
`

export const RightIcon = styled.div`
    height: 24px;
    width: 24px;
`
